import {ApiClient} from './api'

export class AdyenPaymentsService {
    baseUrl = '/api/adyen/payments'
    apiClient = null

    constructor(token, site) {
        this.apiClient = new ApiClient(this.baseUrl, token, site)
    }

    async submitPayment(adyenStateData, basketId, customerId, isExpress = false, applePayAmount) {
        const res = await this.apiClient.post({
            body: JSON.stringify({
                data: adyenStateData,
                applePayAmount: applePayAmount
            }),
            headers: {
                customerid: customerId,
                basketid: basketId
            }
        })
        const jsonResponse = await res.json()
        localStorage.setItem('basketid', basketId)
        if (jsonResponse?.merchantReference && !isExpress) {
            // No need to set these for Express Orders
            localStorage.setItem('orderInProgress', jsonResponse.merchantReference)
            localStorage.setItem('paymentInProgress', jsonResponse?.action?.paymentMethodType)
        }
        if (isExpress) {
            localStorage.setItem('expressOrderInProgress', true)
        }
        if (res.status >= 300) {
            throw new Error(jsonResponse.errorMessage || 'Payment failed')
        } else {
            return jsonResponse
        }
    }
}
